import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { provideTranslations } from '../../utils/translations-util';

@Component({
  selector: 'app-no-route-found-page',
  imports: [IpoTranslatePipe],
  template: `
    <div class="{{ backgroundImageClass }}">
      <div class="page-container">
        <div class="container">
          <p>
            {{ 'firstPart' | translate }}
            <a [attr.href]="linkUrl" rel="noopener noreferrer">{{
              urlReference | translate
            }}</a>
            {{ 'secondPart' | translate }}
          </p>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../../../shared/styles/error-page.scss'],
  providers: [
    provideTranslations({
      sv: {
        firstPart: 'Denna sida finns inte. Följ länken till',
        secondPart: 'för att komma till vår förstasida.',
        globalConnectUrlRef: 'https://globalconnect.se',
      },
      fi: {
        firstPart: 'Tätä sivua ei ole olemassa. Seuraa linkkiä osoitteeseen',
        secondPart: 'päästäksesi etusivullemme.',
        globalConnectUrlRef: 'https://privat.globalconnect.fi',
      },
    }),
  ],
})
export class NoRouteFoundPageComponent implements OnInit {
  linkUrl: string;
  backgroundImageClass: string;
  urlReference: string;

  ngOnInit(): void {
    this.urlReference = 'globalConnectUrlRef';
    this.linkUrl = environment.globalConnectSe.publicWebHost;
    this.backgroundImageClass = 'bg-img-ipo';
  }
}
